module.exports = __webpack_public_path__ + "img/banner4-02.e97981f1.jpg";